const config = {
  serviceHost: "https://staging.api.golanis.com/",
  stripePublicApiKey: "pk_test_T61ffIlMPN7oPaSEbzaf4hsI005bbUZ9pV"
};

export default config;
